// extracted by mini-css-extract-plugin
export default {"myLocationButton":"DataCollectorMap_myLocationButton__eIY1i","fetchingLocation":"DataCollectorMap_fetchingLocation__fP7CR"};